import { CircularProgress } from '@material-ui/core/';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Moment from 'moment';
import MUIDataTable from 'mui-datatables';
import QueryString from 'querystring';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import axios from '../../axios-default';
import '../../util/string';
//Components
import SideNav from '../../components/Admin/SideNav';

import { getWebAbsPath } from '../../util/path';

const title = 'Activity Log';

const CaseStyles = makeStyles((theme) => ({
    '@global': {
        body: {
            background: '#fdfdfd',
        },
    },
    root: {
        flexGrow: 1,
    },
    rootContainer: {
        padding: 16,
        margin: '8px 0px 0px 238px',
        [theme.breakpoints.between('xs', 'sm')]: {
            margin: '12px 0px 0px 0px',
            width: '100%',
        },
        width: 'calc(100% - 238px)',
    },
    scanBox: {
        padding: 16,
        margin: '8px 0px',
    },
    textField: {
        // marginLeft: "8px",
        // marginRight: "8px",
        '& label.Mui-focused': {
            color: 'black',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'black',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: 'grey',
            },
            '&:hover fieldset': {
                borderColor: 'black',
            },
            '&.Mui-focused fieldset': {
                borderColor: 'black',
            },
        },
    },
    dateField: {
        width: '100%',
    },
    formControl: {
        width: '100%',
    },
    dense: {
        marginTop: 16,
        marginLeft: 0,
    },
    submitBtn: {
        backgroundColor: '#061a2e !important',
        color: 'white',

        padding: '8px 24px',
        margin: '12px 0px',
    },
    linkBtn: {
        background: 'rgba(89,54,135,1)',
        color: 'white',
        padding: '4px 24px',
        fontWeight: 300,
        margin: '16px 0px',
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            padding: '4px 72px',
            width: 'unset',
        },
        '&:hover': {
            background: 'rgb(77, 74, 142)',
            color: 'white',
        },
    },
}));

const columns = [
    {
        name: 'case_id',
        label: 'Case Id',
    },
    {
        name: 'title',
        label: 'Title',
    },
    {
        name: 'first_name',
        label: 'First Name',
    },
    {
        name: 'last_name',
        label: 'Last Name',
    },
    {
        name: 'status_param1',
        label: 'Status Param1',
    },
    {
        name: 'status_param2',
        label: 'Status Param2',
    },
    {
        name: 'status_remarks',
        label: 'Status Remarks',
    },
    {
        name: 'type',
        label: 'Type',
    },
    {
        name: 'new_status',
        label: 'New Status',
    },
    {
        name: 'patient_first_name',
        label: 'Patient First Name',
    },
    {
        name: 'patient_last_name',
        label: 'Patient Last Name',
    },
    {
        name: 'created_date',
        label: 'Created Date',
    },
];

const options = {
    filter: true,
    selectableRows: 'none', // You can change this based on your needs
    viewColumns: false,
    responsive: 'vertical',
    rowsPerPage: 10,
    minHeight: '300px', // Set the minimum body height
    maxHeight: '10000px', // Set the maximum body height
};

export const CasesActivityLog = () => {
    const classes = CaseStyles();
    const history = useHistory();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchData({ pageSize: 10, page: 0 });
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }, []);

    const fetchData = async (query) => {
        const { pageSize, page: pageNo, search, orderBy, orderDirection } = query;

        try {
            if (orderBy && orderBy.field.endsWith('_label')) {
                orderBy.field = orderBy.field.slice(0, -6);
            }

            const queryParams = QueryString.stringify({
                searchStr: typeof search !== 'string' || String.isBlank(search) ? undefined : search,
                sortBy: orderBy && orderBy.field,
                sortDir: orderDirection,
                statusFilter: 'ALL',
                pageSize,
                pageNo,
                all: 1,
            });

            const response = await axios.get(`/case/caseActivityLog?${queryParams}`);

            const responseData = response.data;

            const formattedData = responseData.case.map((c) => {
                const formattedObject = {};
                columns.forEach((column) => {
                    if (column.name === 'created_date') {
                        formattedObject[column.name] = Moment(c[column.name]).format('YYYY-MM-DD ddd hh:mm A');
                    } else {
                        formattedObject[column.name] = c[column.name];
                    }
                });
                return formattedObject;
            });

            setData(formattedData);
            setLoading(false);
        } catch (err) {
            console.error(err);
            if (err.response && err.response.statusText === 'Unauthorized') {
                localStorage.removeItem('auth-token');
                localStorage.removeItem('expirationDate');
                localStorage.removeItem('role');
                history.replace('/login');
            }
        }
    };

    return (
        <div>
            <SideNav />
            <Grid container className={classes.rootContainer}></Grid>
            <Grid container className={classes.rootContainer} style={{ marginTop: 0 }}>
                {!loading ? (
                    <div style={{ display: 'contents' }}>
                        <Grid container>
                            <Grid
                                item
                                xs={12}
                                style={{
                                    padding: 8,
                                }}
                            >
                                <h1
                                    style={{
                                        marginBlockEnd: 0,
                                    }}
                                >
                                    {title}
                                </h1>

                                <hr />
                            </Grid>

                            <Grid
                                item
                                xs={12}
                                style={{
                                    padding: 8,
                                    textAlign: 'center',
                                }}
                            >
                                <img
                                    style={{ width: '100%', maxWidth: 800 }}
                                    src={getWebAbsPath('/img/account1.png')}
                                />
                            </Grid>

                            <Grid xs={12} style={{ padding: 8 }}>
                                <MUIDataTable
                                    title={`${title}`}
                                    data={data}
                                    columns={columns}
                                    options={options}
                                    minBodyHeigh={700}
                                    maxBodyHeight={1000}
                                />
                            </Grid>
                        </Grid>
                    </div>
                ) : (
                    <Grid container style={{ display: 'flex', justifyContent: 'center' }}>
                        <CircularProgress style={{ color: 'rgb(6,26,46)' }} />
                    </Grid>
                )}
            </Grid>
        </div>
    );
};
